import { useState, useRef, useEffect } from "react";
import "./App.css";
import gmail from "./assets/gmail.png";

const FALLBACK_PIN = "78686";
const APP_PIN = process.env.REACT_APP_BOT_PIN || FALLBACK_PIN;

function App() {
  const [page, setPage] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [subjects, setSubjects] = useState("");
  const [recipients, setRecipients] = useState("");
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [delay, setDelay] = useState(5);
  const [sendingStatus, setSendingStatus] = useState([]);

  const [logoMoving, setLogoMoving] = useState(false);
  const [welcomeMessage, setWelcomeMessage] = useState("");
  const [flowerEffect, setFlowerEffect] = useState(false);

  // 🔒 PIN state
  const [pinInput, setPinInput] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [pinError, setPinError] = useState("");

  const statusRef = useRef(null);

  useEffect(() => {
    if (!isUnlocked) {
      document.body.style.background = "rgb(240,240,245)";
    } else {
      document.body.style.background = "";
    }
    return () => {
      document.body.style.background = "";
    };
  }, [isUnlocked]);

  const tryUnlock = (e) => {
    e.preventDefault();
    if (pinInput === APP_PIN) {
      setIsUnlocked(true);
      setPinError("");
    } else {
      setPinError("❌ Incorrect PIN");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!isUnlocked) {
      setError("🔒 App is locked. Enter PIN first.");
      return;
    }

    const cleanPassword = password.trim().replace(/\s+/g, "");
    setLogoMoving(true);
    setFlowerEffect(true);

    try {
      const response = await fetch("http://127.0.0.1:5000/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password: cleanPassword }),
      });
      const data = await response.json();

      if (data.success) {
        setError("");
        setPage("compose");
        setWelcomeMessage(`Welcome, ${email}!`);
        setTimeout(() => setWelcomeMessage(""), 3000);
      } else {
        setError(data.error || "❌ Login failed. Check your credentials.");
        setFlowerEffect(false);
      }
    } catch (err) {
      setError("❌ Error connecting to server: " + err.message);
      setFlowerEffect(false);
    } finally {
      setLogoMoving(false);
    }
  };

  const handleFileChange = (e) => {
    setFiles([...files, ...Array.from(e.target.files)]);
  };

  const sendSingleEmail = async (recipient, subject) => {
    if (!isUnlocked) {
      setSendingStatus((prev) => [...prev, `🔒 Locked: not authorized to send`]);
      return false;
    }

    const cleanPassword = password.trim().replace(/\s+/g, "");
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", cleanPassword);
      formData.append("subjects", subject);
      formData.append("recipients", recipient);
      formData.append("message", message);
      formData.append("delay", 0);

      files.forEach((file) => {
        formData.append("files", file);
      });

      const response = await fetch("http://127.0.0.1:5000/send-emails", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        setSendingStatus((prev) => [...prev, `✅ Email sent to ${recipient}`]);
        return true;
      } else {
        setSendingStatus((prev) => [
          ...prev,
          `❌ Failed to ${recipient}: ${data.error}`,
        ]);
        return false;
      }
    } catch (err) {
      setSendingStatus((prev) => [
        ...prev,
        `❌ Error to ${recipient}: ${err.message}`,
      ]);
      return false;
    }
  };

  const handleSend = async (e) => {
    e.preventDefault();
    setSendingStatus([]);

    if (!isUnlocked) {
      setSendingStatus([`🔒 Locked: enter PIN to enable sending.`]);
      return;
    }

    if (statusRef.current) {
      statusRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    const subjectLines = subjects.split("\n").filter((s) => s.trim() !== "");
    const recipientLines = recipients
      .split(/[\n,]+/)
      .map((r) => r.trim())
      .filter((r) => r !== "");

    for (let i = 0; i < recipientLines.length; i++) {
      const recipient = recipientLines[i];
      const subject = subjectLines[i % subjectLines.length];
      await sendSingleEmail(recipient, subject);
      await new Promise((resolve) => setTimeout(resolve, delay * 1000));
    }
  };

  return (
    <div className="app">
      <header className="header">
        <div className="logo">Email Sending Bot</div>
        <img
          src={gmail}
          alt="Site logo"
          className={`nav-logo ${logoMoving ? "logo-loading" : ""}`}
        />
      </header>

      {/* 🔒 PIN gate on login page */}
      {page === "login" && !isUnlocked && (
        <div className="center-container">
          <form onSubmit={tryUnlock} className="form-box">
           <h3>Buy &amp; Enter PIN from WhatsApp to Unlock</h3>
            <input
              type="password"
              maxLength={5}
              className="pin-input"
              value={pinInput}
              onChange={(e) => setPinInput(e.target.value.replace(/\D/g, ""))}
              placeholder="*****"
              required
            />

            {/* ✅ Error message ab input ke niche aur button ke upar hai */}
            {pinError && <div className="pin-error">{pinError}</div>}

            <button type="submit">Unlock</button>
            
                    <div className="contact-buttons">
            <a
              href="https://wa.me/923138958226" 
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                alt="WhatsApp"
              />
              WhatsApp
            </a>
            <a
              href="mailto:zvhdnky@gmail.com"
              className="email-btn"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/732/732200.png"
                alt="Email"
              />
              Email
            </a>
          </div>


          </form>
        </div>
      )}

      {welcomeMessage && <div className="welcome-popup">{welcomeMessage}</div>}

      {page === "login" && (
        <div className="center-container">
          <form
            onSubmit={handleLogin}
            className={`form-box ${flowerEffect ? "flower-effect" : ""}`}
          >
            <h2>Enter your Email and Password</h2>
            {error && <div className="error-popup">{error}</div>}

            <label>Gmail:</label>
            <input
              type="email"
              placeholder="Enter your Gmail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={!isUnlocked}
            />

            <label>16-digit App Password:</label>
            <input
              type="password"
              placeholder="Enter 16-digit password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={!isUnlocked}
            />

            <button type="submit" disabled={!isUnlocked}>OK</button>
          </form>
        </div>
      )}

      {page === "compose" && (
        <div className="center-container" ref={statusRef}>
          <form onSubmit={handleSend} className="form-box">
            <h2>Compose & Send Emails {isUnlocked ? "(Unlocked)" : "(Locked)"}</h2>

            <label>Subjects (one per line):</label>
            <textarea
              rows={4}
              placeholder="Subject 1&#10;Subject 2"
              value={subjects}
              onChange={(e) => setSubjects(e.target.value)}
              required
            />

            <label>Message:</label>
            <textarea
              placeholder="Write message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            <label>Recipient Emails (one per line):</label>
            <textarea
              rows={4}
              placeholder="example1@gmail.com&#10;example2@yahoo.com"
              value={recipients}
              onChange={(e) => setRecipients(e.target.value)}
              required
            />

            <label>Attach Files:</label>
            <input type="file" multiple onChange={handleFileChange} />
            <ul className="file-list">
              {files.map((f, idx) => (
                <li key={idx}>{f.name}</li>
              ))}
            </ul>

            <label>Delay (seconds between emails):</label>
            <input
              type="number"
              min="5"
              value={delay}
              onChange={(e) => setDelay(Number(e.target.value))}
              required
            />

            <button type="submit" disabled={!isUnlocked}>Send Emails</button>
          </form>

          {sendingStatus.length > 0 && (
            <div className="status-popup">
              {sendingStatus.map((status, idx) => (
                <div key={idx}>{status}</div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default App;
